import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Share2, Twitter, Linkedin, MessageSquare } from 'lucide-react';

const CardFooter = ({ cardUrl, theme, themeVars }) => {
  const { isDark, subtleBorder, mutedText } = themeVars;
  const [showQR, setShowQR] = useState(false);

  return (
    <div className="mt-10 text-center">
      {/* Share Actions */}
      <div className="flex items-center justify-center gap-3 mb-4">
        <button onClick={() => setShowQR(!showQR)} className="flex items-center gap-1.5 text-xs font-semibold transition-opacity hover:opacity-70" style={{ color: mutedText }} data-testid="share-qr-btn">
          <Share2 className="w-3.5 h-3.5" /> {showQR ? 'Hide QR' : 'QR'}
        </button>
        <span style={{ color: subtleBorder }}>|</span>
        <a href={`https://twitter.com/intent/tweet?text=Check out my digital card&url=${encodeURIComponent(cardUrl)}`} target="_blank" rel="noopener noreferrer"
          className="transition-opacity hover:opacity-70" style={{ color: mutedText }} data-testid="share-twitter">
          <Twitter className="w-3.5 h-3.5" />
        </a>
        <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(cardUrl)}`} target="_blank" rel="noopener noreferrer"
          className="transition-opacity hover:opacity-70" style={{ color: mutedText }} data-testid="share-linkedin">
          <Linkedin className="w-3.5 h-3.5" />
        </a>
        <a href={`https://wa.me/?text=${encodeURIComponent(`Check out my digital card: ${cardUrl}`)}`} target="_blank" rel="noopener noreferrer"
          className="transition-opacity hover:opacity-70" style={{ color: mutedText }} data-testid="share-whatsapp">
          <MessageSquare className="w-3.5 h-3.5" />
        </a>
      </div>
      
      {showQR && (
        <div className="mb-6 p-4 rounded-xl inline-block" style={{ background: '#fff' }} data-testid="public-qr-code">
          <QRCodeSVG value={cardUrl} size={140} level="H" includeMargin={false} />
          <p className="text-[10px] text-gray-500 text-center mt-2">Scan to save this card</p>
        </div>
      )}
      
      <p className="text-[10px] uppercase tracking-widest font-semibold" style={{ color: mutedText }}>
        Powered by <a href="/" className="hover:opacity-70 transition-opacity" style={{ color: isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)' }}>Plexata</a>
      </p>
    </div>
  );
};

export default CardFooter;
